import { CALL_API } from '../constants/api';
import {
  GET_SEARCH_SUGGESTIONS_FAILURE,
  GET_SEARCH_SUGGESTIONS_REQUEST,
  GET_SEARCH_SUGGESTIONS_SUCCESS,
} from '../constants/constructor-autosuggestions';

/**
 * @param {string} searchTerm
 * @param {number} numberRequestedItems
 * @returns {*}
 */
export function getSearchSuggestionsSuccess(searchTerm, numberRequestedItems) {
  return {
    type: GET_SEARCH_SUGGESTIONS_SUCCESS,
    payload: {
      searchTerm,
      numberRequestedItems,
    },
  };
}

/**
 * @param {string} searchTerm
 * @param {number} numberRequestedItems
 * @returns {*}
 */
export function getSearchSuggestionsRequest(searchTerm, numberRequestedItems) {
  return {
    type: GET_SEARCH_SUGGESTIONS_REQUEST,
    payload: {
      searchTerm,
      numberRequestedItems,
    },
  };
}

/**
 *
 * @param {*} details
 * @returns {*}
 */
export function getSearchSuggestionsFailure(details) {
  return {
    type: GET_SEARCH_SUGGESTIONS_FAILURE,
    payload: {
      details,
    },
  };
}

/**
 * Function to send over the search term to be requested to the endpoint
 * @param {string} searchTerm
 * @param {number} numberRequestedItems
 * @returns {{type, payload: array}}
 */
export function getSearchSuggestions(searchTerm, numberRequestedItems) {
  return {
    actions: {
      error: getSearchSuggestionsFailure,
      start: getSearchSuggestionsRequest,
      success: getSearchSuggestionsSuccess,
    },
    method: 'get',
    type: CALL_API,
    url: `products/autosuggest/${searchTerm}/${numberRequestedItems}`,
  };
}
